import { IRequestEventHandler, CoreApiResponse } from "../common";
import { ContentType } from '../../fetchApiDistributor/contentTypes';
import BaseCoreApiRequest from "../baseCoreApiRequest";
import { INews2User } from '../../coreapi-dto/service/newsChat';


class News2UserRequest extends BaseCoreApiRequest {

    protected _routePrefix: string
    protected _eventHandler: IRequestEventHandler;
    protected readonly _token: string

    constructor(baseUrl: string, token: string, eventHandler: IRequestEventHandler) {
        super(baseUrl)
        this._routePrefix = 'RedmineNews2Users'
        this._eventHandler = eventHandler
        this._token = token
    }

    postNews2User(body: INews2User, callback: (e: CoreApiResponse<string>) => void) {
        this.post<string>(`${this._baseUrl}/${this._routePrefix}`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e: CoreApiResponse<string>) => {
            if (this._eventHandler) {
                if (e.respType === 'isFailed') {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback(e);
        })
    }




}

export default News2UserRequest